import { isNil } from 'lodash';

export function convertPercentageToIndex(fuelLevel) {
  if (isNil(fuelLevel)) {
    return undefined;
  }

  return Math.round(fuelLevel / 12.5);
}

export function convertIndexToPercentage(fuelLevel) {
  if (isNil(fuelLevel)) {
    return undefined;
  }

  return Number(fuelLevel) * 12.5;
}
